const URL_CONFIG = {
  iq: {
    x: {
      test: {
        aichat: 'https://api-aichat-savana-iq.urbanic-cs.net',
        insite: 'https://api-shop-savana-iq.mayfair-inc.net',
      },
      prod: {
        aichat: 'https://api-aichat-savana-iq.urbanic-cs.com',
        insite: 'https://api-shop-iq.savana.com',
      },
    },
  },
  in: {
    x: {
      test: {
        aichat: 'https://api-aichat-savana-in.urbanic-cs.net',
        insite: 'https://api-shop-x.mayfair-inc.net',
      },
      prod: {
        aichat: 'https://api-aichat-savana-in.urbanic-cs.com',
        insite: 'https://api-shop-in.savana.com',
      },
    },
    urbanic: {
      test: {
        aichat: 'https://api-aichat-urbanic-in.urbanic-cs.net',
        insite: 'https://api-in.urbanic.net'
      },
      prod: {
        aichat: 'https://api-aichat-urbanic-in.urbanic-cs.com',
        insite: 'https://api-shop-in.urbanic.com',
      },
    },
  },
};

export const getCountry = () => {
  const hostname = window.location.hostname;
  if (hostname.startsWith('aichat-in')) {
    return 'in';
  }
  return 'iq';
};

// Helper function to get accountId from URL path
const getAccountIdFromRoute = () => {
  const isInsideAccountScopedURLs =
    window.location.pathname.includes('/app/accounts');

  if (isInsideAccountScopedURLs) {
    const pathParts = window.location.pathname.split('/');
    const accountIdIndex = pathParts.findIndex(part => part === 'accounts') + 1;
    if (accountIdIndex < pathParts.length) {
      return Number(pathParts[accountIdIndex]);
    }
  }

  return null;
};

const accountIdMap = {
  test: {
    1: 'urbanic',
    2: 'x',
  },
  prod: {
    1: 'urbanic',
    2: 'x',
  },
};

export const getSite = () => {
  const country = getCountry();
  const accountId = getAccountIdFromRoute();
  const environment = getEnvironment();
  const site = accountIdMap[environment][accountId] || 'x';
  if (country === 'in') {
    return site;
  }
  return 'x';
};

export const ENVIRONMENT = {
  TEST: 'test',
  PRODUCTION: 'prod',
};

export const getBaseUrl = urlType => {
  const country = getCountry();
  const site = getSite();
  const environment = getEnvironment();
  return URL_CONFIG[country][site][environment][urlType];
};

const DOMAIN_PATTERNS = {
  [ENVIRONMENT.TEST]: ['urbanic-cs.net', 'localhost', '127.0.0.1'],
  [ENVIRONMENT.PRODUCTION]: ['urbanic-cs.com'],
};

export const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (
    DOMAIN_PATTERNS[ENVIRONMENT.TEST].some(domain => hostname.includes(domain))
  ) {
    return ENVIRONMENT.TEST;
  }

  if (
    DOMAIN_PATTERNS[ENVIRONMENT.PRODUCTION].some(domain =>
      hostname.includes(domain)
    )
  ) {
    return ENVIRONMENT.PRODUCTION;
  }

  return ENVIRONMENT.TEST;
};

export const isLocalEnvironment = () => getEnvironment() === ENVIRONMENT.LOCAL;

export const isTestEnvironment = () => getEnvironment() === ENVIRONMENT.TEST;

export const isProductionEnvironment = () =>
  getEnvironment() === ENVIRONMENT.PRODUCTION;

export const getApiBaseUrl = () => {
  return getBaseUrl('aichat');
};

export const getCRMOrigin = () => {
  const environment = getEnvironment();
  switch (environment) {
    case ENVIRONMENT.PRODUCTION:
      return 'https://crm.mayfair-inc.com';
    default:
      return 'https://crm.mayfair-inc.net';
  }
};

export const getInsiteOrigin = () => {
  const environment = getEnvironment();
  const country = getCountry();
  if (getSite() === 'urbanic') {
    switch (environment) {
      // urbanic只有IN环境
      case ENVIRONMENT.PRODUCTION:
        return 'https://in.urbanic.com';
      default:
        return 'https://in.urbanic.net';
    }
  } else {
    switch (environment) {
      case ENVIRONMENT.PRODUCTION:
        return `https://www.savana.com/${country}`;
      default:
        return `https://www.savana.net/${country}`;
    }
  }
};

// 获取扩展包的域名
export const getExternalDomain = () => {
  const environment = getEnvironment();
  switch (environment) {
    case ENVIRONMENT.PRODUCTION:
      return 'https://aichat.urbanic-cs.com';
    default:
      return 'https://aichat.urbanic-cs.net';
  }
};

export default {
  ENVIRONMENT,
  getEnvironment,
  isLocalEnvironment,
  isTestEnvironment,
  isProductionEnvironment,
  getApiBaseUrl,
  getCRMOrigin,
};
